import { apiUrl, castError } from 'common/utils';

const fetchMerchants = async (): Promise<IMerchant[]> =>
  fetch(apiUrl('merchants/all')).then(castError);

export default fetchMerchants;
